import React from 'react';

function Jobs() {
    return (
        <section id="jobs">
            <div className="container wow fadeIn">
                <div className="row">
                    <div className="col-lg-9 text-center text-lg-left">
                        <h3 className="cta-title">Oportunidades</h3>
                        <p className="cta-text">Diversas oportunidades para estudantes e recém-graduados</p>
                    </div>
                    <div className="col-lg-3 cta-btn-container text-center">
                        <a className="cta-btn align-middle" href="https://sigarra.up.pt/feup/pt/web_base.gera_pagina?p_pagina=entrada%20da%20bolsa%20de%20emprego">Visitar website</a>
                    </div>
                </div>

            </div>
        </section>
    );
}

export default Jobs;